module.exports = __webpack_public_path__ + "static/media/rectangle-border.7c5819e1.png";